import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { MacroCalc } from "../components/MacroCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.macro_tool_name()}
        toolPath="/macro-calculator"
      />
      <SciHeader title={m.macro_h1()} intro={m.macro_intro()} />
      <MacroCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.macro_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.macro_ex1(), m.macro_ex2(), m.macro_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.macro_faq_q1(), a: m.macro_faq_a1() },
          { q: m.macro_faq_q2(), a: m.macro_faq_a2() },
          { q: m.macro_faq_q3(), a: m.macro_faq_a3() },
          { q: m.macro_faq_q4(), a: m.macro_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
